import {
  FormControlError,
  FormControlErrorIcon,
  FormControlErrorText,
  AlertCircleIcon,
  Box,
} from "@gluestack-ui/themed";
import { IInputError } from "./types";

export const InputError = ({ errorMessage }: IInputError) => {
  if (!errorMessage) return null;

  return (
    <Box w="$full" minW={0}>
      <FormControlError w="$full">
        <FormControlErrorIcon size="xs" color="$error700" as={AlertCircleIcon} />
        <FormControlErrorText flex={1} minWidth={0}>
          {errorMessage}
        </FormControlErrorText>
      </FormControlError>
    </Box>
  );
};
